module.exports=/[\0-\x1F\x7F-\x9F]/


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/uc.micro/categories/Cc/regex.js
// module id = 2154
// module chunks = 69